import { object, string, date } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_VALID } from '@occc-app/lib/constants/validationMessages';
import { calcDateTime, isDateTimeValid } from '@occc-app/lib/date';
import { validatePhoneNumber } from '@occc/utils-phone-number';

export const PHONE_NUMBER_REQUIRED_MESSAGE = 'Phone number is required.';
const LOYALTY_PROGRAM_MEMBERSHIP_MIN_AGE = 16;
const MAX_ALLOWED_DATE_MESSAGE = `Member should reach ${LOYALTY_PROGRAM_MEMBERSHIP_MIN_AGE} years old`;
const MIN_ALLOWED_DATE_MESSAGE = 'Date must be after 1900';

const isDateValid = (date: Date | null | undefined) => {
  if (!date) return true;
  return isDateTimeValid(date);
};

export const maxAllowedDate = calcDateTime(
  new Date(),
  'sub',
  LOYALTY_PROGRAM_MEMBERSHIP_MIN_AGE,
  'year',
);

const schema = object({
  birthdate: date()
    .min(new Date(1900, 0, 1), MIN_ALLOWED_DATE_MESSAGE)
    .max(maxAllowedDate, MAX_ALLOWED_DATE_MESSAGE)
    .nullable()
    .refine(isDateValid, 'Incorrect date format')
    .optional(),
  email: string().email(IS_VALID).nullable().optional(),
  firstName: string().nullable().optional(),
  lastName: string().nullable().optional(),
  phone: string({ message: PHONE_NUMBER_REQUIRED_MESSAGE })
    .refine(validatePhoneNumber, IS_VALID)
    .optional(),
  primaryAddress: object({
    address1: string().nullable().optional(),
    city: string().nullable().optional(),
    state: object({}).nullable().optional(),
    zipcode: string().nullable().optional(),
  })
    .nullable()
    .optional(),
});

export const validateMemberUpdate = makeValidate(schema);
